export const ROLES = [
    { key: "dad", label: "Dad" },
    { key: "mom", label: "Mom" },
    { key: "mama", label: "Mama (Maternal Uncle)" },
    { key: "mami", label: "Mami (Maternal Aunt)" },
    { key: "chachu", label: "Chachu (Paternal Uncle)" },
    { key: "chachi", label: "Chachi (Paternal Aunt)" },
    { key: "grandpa", label: "Grandpa" },
    { key: "grandma", label: "Grandma" },
    { key: "sibling", label: "Sibling" },
    { key: "bestfriend", label: "Best Friend" },
    { key: "pet", label: "Pet" },
    { key: "other", label: "Other" },
];
